/** 2026-09-10 00:00:00 UTC — locked preview since label */
export const LOCKED_PREVIEW_JOB_TIME = 1757462400;

export const insightCopy = {
  mn: {
    badge: 'Zangia Plus',
    title: 'Бусад горилогчидтой харьцуулах',
    subtitle:
      'Тус ажлын байрны зард ажил горилогчдын мэдээлэлд үндэслэсэн болно.',
    adViews: 'Зарын хандалт',
    adViewsTotal: 'Нийт зарын хандалтын тоо',
    applicants: 'Энэ зард горилогчид',
    total: 'Нийт горилогч',
    yourCvOnly: '/Таны cv/',
    last7: 'Сүүлийн 7 хоногт',
    education: 'Боловсролын түвшин',
    experience:
      'Ажил горилогчид болон Ажлын байрны зарын ур чадвар',
    skills: 'Ур чадварын давхардал',
    skillsEmpty: 'Одоогоор давхардал байхгүй байна',
    collapse: 'Хураах',
    expand: 'Дэлгэх',
  },
  en: {
    badge: 'Zangia Plus',
    title: 'Compare with other applicants',
    subtitle: 'Based on applicants who applied to this job posting.',
    adViews: 'Ad views',
    adViewsTotal: 'Total ad views',
    applicants: 'Applicants for this job',
    total: 'Total applicants',
    yourCvOnly: '/Your CV/',
    last7: 'Last 7 days',
    education: 'Education level',
    experience: 'Applicant and job skill match',
    skills: 'Skill overlap',
    skillsEmpty: 'No skill overlap yet',
    collapse: 'Collapse',
    expand: 'Expand',
  },
} as const;
